import styled, { css } from 'styled-components';

import omitProps from 'ggApp/utils/omitProps';

import CircleLoader from 'ggApp/shared/components/CircleLoader';
import { Subheadline } from 'ggApp/shared/components/EmptyCartPage/EmptyCart/styled';

import PlayIcon from 'ggApp/shared/screens/ProductDetailsPage/Player/Assets/Play';
import PauseIcon from 'ggApp/shared/screens/ProductDetailsPage/Player/Assets/Pause';

export const VideoContent = styled(omitProps('loading')('div'))`
    ${({ loading }) => loading && css`
        visibility: hidden;
    `};
    height: 100%;
    & iframe {
        border-radius: 8px;
    }
`;

export const VideoPanel = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
`;

export const Loader = styled(CircleLoader)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
`;

const ControlStyles = css`
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: transform 500ms;
    &:hover {
        transform: scale(1.1);
    }
`;


export const Play = styled(PlayIcon)`
    ${ControlStyles};
    ${({ controlsPosition }) => controlsPosition === "center" && css`
        top: calc(50% - 39px);
        left: calc(50% - 39px);
        transform: scale(1.5);
        &:hover {
            transform: scale(1.6);
        }
        ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
            transform: unset;
            &:hover {
                transform: unset;
            }
        `}
    `}
`;

export const Pause = styled(PauseIcon)`
    ${ControlStyles};
    ${({ controlsPosition }) => controlsPosition === "center" && css`
        top: calc(50% - 39px);
        left: calc(50% - 39px);
        display: none;
        &:hover {
            display: block;
        }
    `}
`;

export const Title = styled(Subheadline)`
    position: absolute;
    left: 24px;
    color: #333;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        left: 16px;
        top: -20px;
        text-align:left;
    `}
`;
